window.SMTX.globalSearch  = (function(){

  // toogle search overlay

  $(document).on('click', "[data-toggle-search]", function() {
    var $me = $(this);
    $me.toggleClass('is-open');

    if( $me.hasClass('is-open') ){
      openSearchOverlay();
    }else{
      closeSearchOverlay();
    }
  });

  $(document).on('click', "[data-close-search]", function() {
    $("[data-toggle-search]").trigger('click');
  });


  function openSearchOverlay(){
    log('open search');
    $('[data-id="search-overlay"]').addClass('is-active');
    $('[data-id="search-overlay"] input[name="s"]').focus();
  }

  function closeSearchOverlay(){
    log('close overlay');
    $('[data-id="search-overlay"]').removeClass('is-active');
    $('[data-id="search-overlay"] input[name="s"]').blur();
  }


  return {

  };

})();
